"use strict";

const IExecConfig = require('./IExecConfig');

class IExecModule {
  constructor() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!args[0]) {
      throw Error("".concat(this.constructor.name, " requires at least one argument"));
    }

    if (args[0] instanceof IExecConfig) {
      [this.config] = args;
    } else {
      this.config = new IExecConfig(...args);
    }
  }

  static fromConfig(config) {
    if (!(config instanceof IExecConfig)) throw Error('fromConfig requires an instance of IExecConfig');
    return new this.prototype.constructor(config);
  }

}

module.exports = IExecModule;